import { render, staticRenderFns } from "./Pupils.vue?vue&type=template&id=db77e8f0&"
import script from "./Pupils.vue?vue&type=script&lang=js&"
export * from "./Pupils.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports